<template>
  <div class="page">
    <h1 class="text-h3 mb-4">
      {{ $t("annotation.title") }}
      <div class="subtitle-1" v-if="list">
        <span class="grey--text mb-2">{{ $t("annotation.total") }}: </span>
        <span class="font-weight-medium">{{ list.length }}</span>
      </div>
    </h1>

    <v-alert type="info" v-if="allSlidesAnnotated"
      >{{ $t("annotation.allAnnotated") }}</v-alert
    >

    <v-btn @click="onClickStart" v-if="list && list.length > 0">{{ $t("button.start") }}</v-btn>
    <v-data-table
      v-if="list"
      :class="{ table: !loading }"
      :items="list"
      :headers="selectedHeaders"
      :loading="loading"
      :loading-text="$t('annotation.table.loading')"
      :no-data-text="$t('annotation.table.empty')"
      :footer-props="footerProps"
      @click:row="onClickRow"
    >
      <template v-slot:item.actions="{ item }">
        <v-icon small @click="onClickSlide(item)">mdi-pencil</v-icon>
      </template>
      <template v-slot:item.projectName="{ item }">
        <span v-if="project(item.project)">
          {{ project(item.project).project_name }}
        </span>
      </template>

      <template v-slot:item.projectDetails="{ item }">
        <span v-if="project(item.project)">
          {{ project(item.project).details | truncate }}
        </span>
      </template>

      <template v-slot:item.annotationClasses="{ item }">
        {{ getAnnotationClasses(item) }}
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { FIND } from "@/store/modules/project";
import { FIND as FIND_ANNOTATION_CLASS } from "@/store/modules/annotationClass";
import {
  ANNOTATE_NEXT,
  CURRENT_SLIDE,
  LOAD_SLIDES_TO_ANNOTATE,
  SET_CURRENT_INDEX
} from "@/store/modules/annotation";
import { LIST } from "@/store/modules/annotation";

export default {
  computed: {
    ...mapState({
      token: state => state.authentication.keycloak.token,
      loading: state => state.annotation.loading
    }),
    ...mapGetters({
      list: LIST,
      project: FIND,
      annotationClass: FIND_ANNOTATION_CLASS
    }),
    footerProps() {
      return {
        "items-per-page-options": [5, 10, 15],
        "items-per-page-text": this.$t("annotation.table.footerText")
      }
    },
    headers() {
      return [
        {
          text: this.$t("annotation.table.id"),
          value: "id"
        },
        {
          text: this.$t("annotation.table.project"),
          value: "projectName"
        },
        {
          text: this.$t("annotation.table.description"),
          value: "projectDetails"
        },
        {
          text: this.$t("annotation.table.lookingFor"),
          value: "annotationClasses"
        },
        {
          text: this.$t("annotation.table.actions"),
          value: "actions"
        }
      ]
    },
    selectedHeaders() {
      return this.headers;
    },
    allSlidesAnnotated() {
      return this.$route.query.a === 1;
    }
  },
  methods: {
    getAnnotationClasses(item) {
      return item.annotation_class
        .map(x => this.annotationClass(x))
        .map(x => x.class_name)
        .join(", ");
    },
    onClickRow(slide) {
      const index = this.$store.state.annotation.allIds.indexOf(
        slide.id.toString()
      );
      this.$store.commit(SET_CURRENT_INDEX, index);
      this.goToSlide(slide);
    },
    onClickStart() {
      this.$store.dispatch(ANNOTATE_NEXT);
      this.goToSlide(this.$store.getters[CURRENT_SLIDE]);
    },
    goToSlide(slide) {
      this.$router.push({
        name: "annotator-visualize",
        params: { id: slide.id }
      });
    }
  },
  created() {
    this.$store.dispatch(LOAD_SLIDES_TO_ANNOTATE);
  }
};
</script>

<style lang="css" scoped></style>
